import { render, staticRenderFns } from "./formCustomer.vue?vue&type=template&id=5e962ebc&scoped=true"
import script from "./formCustomer.vue?vue&type=script&lang=js"
export * from "./formCustomer.vue?vue&type=script&lang=js"
import style0 from "./formCustomer.vue?vue&type=style&index=0&id=5e962ebc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e962ebc",
  null
  
)

export default component.exports